module.exports = __webpack_public_path__ + "static/media/Undo.a7ccd392.svg";